var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAirplanedeparture({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "8.5703 -70.9219 103.5137 71.3848",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1152-0.537109L100.977-0.537109C102.881-0.537109 104.492-2.14844 104.492-4.05273C104.492-6.00586 102.881-7.56836 100.977-7.56836L18.1152-7.56836C16.1621-7.56836 14.5996-6.00586 14.5996-4.05273C14.5996-2.14844 16.1621-0.537109 18.1152-0.537109Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9824-27.002L98.0469-44.6777C105.273-46.6309 111.084-52.2461 109.082-57.8613C107.178-62.9395 99.4141-64.1602 92.9688-61.9629L69.3359-53.9062C67.627-53.3203 66.4551-53.3691 64.4531-54.2969L32.666-69.2871C31.543-69.8242 30.3223-69.9219 29.1992-69.5801L26.416-68.75C25.4883-68.457 25.1953-67.334 26.0742-66.3574L48.0957-42.7734L48.9258-46.9238L29.1016-40.1367L37.7441-39.8438L14.7461-47.998C13.623-48.3887 12.6953-48.1934 11.6211-47.2168L10.4004-46.0938C9.57031-45.3613 9.57031-44.3848 10.2539-43.6523L23.584-28.6133C25.5371-26.4648 28.418-26.0742 31.9824-27.002Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirplanedeparture);
export default __webpack_public_path__ + "static/media/airplane.departure.997f256a1ba1351f10dd63cbab4f0e81.svg";
export { ForwardRef as ReactComponent };